const defaultStreamColors = {
  backgroundColor: "#e2e8f0",
  color: "#1e293b",
  borderColor: "#94a3b8",
};

export const competitionStreamsMixin = {
  computed: {
    competitionStreams() {
      return this.$page?.competition?.streams ?? [];
    },
    isSingleStream() {
      return this.availableStreams?.length === 1 ?? true;
    },
    availableStreams() {
      return this.competitionStreams?.available ?? [];
    },
    applicationOverridesForStream() {
      return this.competitionStreams.application_overrides ?? {};
    },
    applicationHasOverridesForStream() {
      return Object.keys(this.applicationOverridesForStream).length > 0;
    }
  },
  methods: {
    findStreamByKey(streams, key) {
      return streams?.available?.find(stream => stream.key === key);
    },
    findStreamNameByKey(streams, key) {
      return this.findStreamByKey(streams, key)?.name ?? "Unknown";
    },
    findStreamColorsByKey(streams, key) {
      const colors = Object.assign(defaultStreamColors, this.findStreamByKey(streams, key)?.colors ?? {});
      return colors
    },
    getStreamByKey(key) {
      return this.competitionStreams?.available?.find(stream => stream.key === key);
    },
    getStreamNameByKey(key) {
      return this.getStreamByKey(key)?.name ?? "Unknown";
    },
    getStreamColorsByKey(key) {
      const colors = Object.assign(defaultStreamColors, this.getStreamByKey(key)?.colors ?? {});
      return colors;
    },
    getStreamTextColorByKey(key) {
      return this.getStreamColorsByKey(key)?.color ?? defaultStreamColors.color;
    },
    getStreamBackgroundColorByKey(key) {
      return this.getStreamColorsByKey(key)?.backgroundColor ?? defaultStreamColors.backgroundColor;
    },
    getStreamBorderColorByKey(key) {
      return this.getStreamColorsByKey(key)?.borderColor ?? defaultStreamColors.borderColor;
    },
    getStreamDescriptionByKey(key) {
      return this.getStreamByKey(key)?.description ?? "Unknown";
    },
    getStreamOverideForKey(streamId, inputKey, item, d = null) {
      if(!this.applicationHasOverridesForStream) {
        return d
      }
      return this.applicationOverridesForStream?.[streamId]?.[inputKey]?.[item] ?? d
    }
  },
}
